import { useUserStore } from "~/store/global/user.store";

export const useHandleLogoNavigation = () => {
    const localePath = useLocalePath();
    const { homepageRef } = storeToRefs(useUserStore());
    const showMobileMenu = useMobileMenuOpen();

    const navigateLink = async () => {
        if (useRoute().path.includes("dashboard")) {
            window.open(localePath("/"), "_blank");
            return;
        }
        if (useRoute().fullPath === "/") {
            showMobileMenu.value = false;
            return homepageRef?.value?.scrollIntoView({ behavior: "smooth", block: "center" });
        }
        await navigateTo(localePath("/"));
    };

    return { navigateLink };
};
